import {
   Organisation,
   OrganisationChangeNotificationDTO,
   OrganisationDetailsUpdateNotificationDTO,
   UserAccount,
   UserDetailsUpdateNotificationDTO,
} from '../api/schemas/schema'
import { IDataContext } from '../interfaces/IDataContext'

export const createUserUpdateEmailRequest = (dataContext: IDataContext, form: UserAccount): OrganisationChangeNotificationDTO => {
   const { userAccount, organisation } = dataContext.state

   const userDetailsUpdateNotificationDTO: UserDetailsUpdateNotificationDTO = {
      email: form.email !== userAccount.email ? form.email : null,
      phoneNumber: form.phoneNumber !== userAccount.phoneNumber ? form.phoneNumber : null,
   }
   const hasChanges = Object.values(userDetailsUpdateNotificationDTO).some((value) => value !== null)

   if (hasChanges) {
      const request: OrganisationChangeNotificationDTO = {
         organisationName: organisation.name,
         userName: `${userAccount.firstName} ${userAccount.lastName}`,
         userEmail: userAccount.email,
         userDetails: userDetailsUpdateNotificationDTO,
      }
      return request
   }

   return null
}

export const createOrganisationUpdateEmailRequest = (dataContext: IDataContext, form: Organisation): OrganisationChangeNotificationDTO => {
   const { organisation, userAccount } = dataContext.state

   const organisationDetailsUpdateNotificationDTO: OrganisationDetailsUpdateNotificationDTO = {
      organisationInvoiceName: form.invoiceName !== organisation.invoiceName ? form.invoiceName : null,
      invoiceReference: form.invoiceReference !== organisation.invoiceReference ? form.invoiceReference : null,
      organisationInvoiceAddress: form.invoiceAddress !== organisation.invoiceAddress ? form.invoiceAddress : null,
      postalCode: form.postalCode !== organisation.postalCode ? String(form.postalCode) : null,
      county: form.county !== organisation.county ? form.county : null,
      phoneNumber: form.phoneNumber !== organisation.phoneNumber ? form.phoneNumber : null,
      email: form.email !== organisation.email ? form.email : null,
      otherInvoiceDetails: form.otherInvoiceDetails !== organisation.otherInvoiceDetails ? form.otherInvoiceDetails : null,
   }
   const hasChanges = Object.values(organisationDetailsUpdateNotificationDTO).some((value) => value !== null)

   if (hasChanges) {
      const request: OrganisationChangeNotificationDTO = {
         organisationName: organisation.name,
         userName: `${userAccount.firstName} ${userAccount.lastName}`,
         userEmail: userAccount.email,
         organisationDetails: organisationDetailsUpdateNotificationDTO,
      }
      return request
   }

   return null
}
